// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3636": "dbfc89bc969b","5015": "59cf926dd644","5817": "767d0497f6c1","7916": "1d3818518fc9","8970": "a7e5b49313f9",}[chunkId] + ".css"
}